import React, { useEffect, useState, useRef } from "react";
import {
  Nav, NavItem, NavLink, TabContent, TabPane,
  FormGroup, Input, Row, Col, Button, Spinner, ModalFooter
} from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {showMessage, addFund } from "store/reducers/common.slice";
import "../../assets/scss/mobile/styleMobile.scss";

export default function AddFund() {
  const history = useHistory();
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("1");
  const [copySuccess, setCopySuccess] = useState("");
  const {isAddFund,addFundLoading} = useSelector(({ common }) => common);
  const selectedRange = location.state?.selectedRange
  const initialAddFundValues = {
    transactionId: "",
    amount: "",
    remark: "",
    transactionFile: null,
  };
 useEffect(() => {
    if (isAddFund) {
      if (formRef && formRef.current) {
          if(formRef.current.values.transactionId){
            formRef.current.resetForm();
            history.push("/app/profile");
          }else{
            formRef.current.resetForm();
          }
          
      }
    }
  }, [isAddFund]);
  if (!selectedRange) {
    history.push("/app/profile");
    return null;
  }
  const validationAddFundSchema = Yup.object().shape({
    transactionId: Yup.string().required("Transaction ID is required"),
    amount: Yup.number().required("Amount is required").positive("Amount must be positive").test(
      "min-max-range",
      `Amount must be between ${selectedRange.startAmountRange} and ${selectedRange.endAmountRange}`,
      (value) => value >= selectedRange.startAmountRange && value <= selectedRange.endAmountRange
    ),
    remark: Yup.string().optional(),
    transactionFile: Yup.mixed().required("Payment receipt is required"),
  });
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    dispatch(showMessage({ message: "Content Copied to Clipboard" }));
    setCopySuccess(text);
  };

  return (
    <main className="trade_page">
      <header>
        <div className="confirm_order_header">
          <div className="close_icon">
            <span className="material-symbols-outlined" onClick={() => history.push('/app/profile')}>
              keyboard_backspace
            </span>
            <span>Add Funds</span>
          </div>
        </div>
      </header>
      <div className="orderBook_tabs my-4">
        {addFundLoading && (
          <div className="spinner-box">
            <Spinner className="ml-2" color="primary" />
          </div>
        )}
        <Nav tabs className="nav nav-pills mb-3" style={{ top: "50px" }}>
          <NavItem>
            <NavLink
              className={`nav-link fw-bold ${activeTab === "1" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("1");
                formRef.current?.resetForm();
              }}
              style={{fontSize: "15px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center", }}
            >
              UPI
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={`nav-link fw-bold ${activeTab === "2" ? "active" : ""}`}
              onClick={() => setActiveTab("2")}
              style={{fontSize: "15px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center", }}
            >
              BANK ACCOUNT
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab} className="mb-3">
          <TabPane tabId="1">
          <div className="card">
            <div className="card-body">
            <Row>
              <Col md={6}>
                <p><strong>UPI ID:</strong> {selectedRange.bankUPI}
                  <Button size="sm" color="link" onClick={() => handleCopy(selectedRange.bankUPI)}>📋</Button>
                  {copySuccess === selectedRange.bankUPI && <span className="text-success"> Copied!</span>}
                </p>
                <p><strong>Range:</strong> {selectedRange.startAmountRange} - {selectedRange.endAmountRange}</p>
              </Col>
              <Col md={6} className="text-center">
                <img src={selectedRange.bankUPIImage} alt="UPI QR" className="rounded shadow mt-2" style={{ width: "150px" }} />
              </Col>
            </Row>
          </div></div>  
          </TabPane>
          <TabPane tabId="2">
           <div className="card">
            <div className="card-body">
            <Row>
              <Col md={6}>
                <p><strong>Bank Name:</strong> {selectedRange.bankName}</p>
                <p><strong>Account No:</strong> {selectedRange.bankAccountNumber}
                  <Button size="sm" color="link" onClick={() => handleCopy(selectedRange.bankAccountNumber)}>📋</Button>
                  {copySuccess === selectedRange.bankAccountNumber && <span className="text-success"> Copied!</span>}
                </p>
                <p><strong>Account Name:</strong> {selectedRange.bankHolderName}
                  <Button size="sm" color="link" onClick={() => handleCopy(selectedRange.bankHolderName)}>📋</Button>
                  {copySuccess === selectedRange.bankHolderName && <span className="text-success"> Copied!</span>}
                </p>
              </Col>
              <Col md={6}>
                <p><strong>IFSC Code:</strong> {selectedRange.bankIFSC}
                  <Button size="sm" color="link" onClick={() => handleCopy(selectedRange.bankIFSC)}>📋</Button>
                  {copySuccess === selectedRange.bankIFSC && <span className="text-success"> Copied!</span>}
                </p>
                <p><strong>Range:</strong> {selectedRange.startAmountRange} - {selectedRange.endAmountRange}</p>
              </Col>
            </Row>
            </div>
            </div>
          </TabPane>
        </TabContent>
        <div className="card">
            <div className="card-body">
        <Formik
          enableReinitialize={true}
          innerRef={formRef}
          initialValues={initialAddFundValues}
          validationSchema={validationAddFundSchema}
          onSubmit={(valuesData) => {
            dispatch(addFund(valuesData));
          }}
        >
          {({ setFieldValue, errors, touched }) => (
            <Form>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Field
                      as={Input}
                      type="text"
                      name="transactionId"
                      placeholder="Transaction ID"
                      invalid={touched.transactionId && !!errors.transactionId}
                    />
                    <span className="text-error"><ErrorMessage name="transactionId" /></span>
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Field
                      as={Input}
                      type="number"
                      name="amount"
                      placeholder="Amount"
                      invalid={touched.amount && !!errors.amount}
                    />
                    <span className="text-error"><ErrorMessage name="amount" /></span>
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Field
                      as={Input}
                      type="text"
                      name="remark"
                      placeholder="Remark"
                    />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Input
                      type="file"
                      name="transactionFile"
                      accept="image/*"
                      onChange={(event) => {
                        const file = event.currentTarget.files[0];
                        if (file) {
                          const reader = new FileReader();
                          reader.onloadend = () => {
                            setFieldValue("transactionFile", reader.result.split(",")[1]); // Base64
                          };
                          reader.readAsDataURL(file);
                        }
                      }}
                    />
                    <span className="text-error"><ErrorMessage name="transactionFile" /></span>
                  </FormGroup>
                </Col>
              </Row>

              <ModalFooter>
                <Button type="submit" color="default" className="btn-icon btn-3 w-100 py-2">Submit</Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </div></div>
      </div>
    </main>
  );
}
